import React from "react";
import {
  Button,
  Portal,
  CloseIcon,
  Pill,
  Text,
  Slider,
  Flex,
} from "@fluentui/react-northstar";
import { Collapse } from "antd";
import { Panel } from "@fluentui/react";
import { useIntelligentGrading } from "../../../../context/useIntelligentGrading";
import { useTranslation } from "react-i18next";

const GRADES = ["A+", "A", "A-", "B+", "B", "F"];
const SUBMISSION_STATUSES = [
  "Pending",
  "Grades Pending",
  "Resubmit",
  "Completed",
];

const BatchGradingFilterModel = ({ open, onHandlePortal }) => {
  const { t } = useTranslation();
  const {
    selectedFilterParameters,
    setSelectedFilterParameters,
    onResetFilter,
    onApplyFilter,
  } = useIntelligentGrading();
  const translation = t("assignment").summary.batch;

  const dismissPanel = () => {
    onHandlePortal(false);
  };

  const handleConfidenceChange = (e, { value }) => {
    setSelectedFilterParameters({
      ...selectedFilterParameters,
      confidence: value,
    });
  };

  return (
    <Panel
      isOpen={open}
      onDismiss={(e) => {
        if (e?.currentTarget?.tagName?.toLowerCase() === "button") {
          dismissPanel();
        }
      }}
      closeButtonAriaLabel={translation.filter.closeFilterPanel}
      headerText={translation.filter.title}
    >
      <div style={{ marginTop: 20 }}>
        <Collapse defaultActiveKey={["1", "2", "3"]}>
          <Collapse.Panel header={translation.filter.filterByGrade} key="1">
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {GRADES.map((grade) => (
                <Pill
                  key={grade}
                  selected={selectedFilterParameters.grades.includes(grade)}
                  selectable
                  onClick={() => {
                    if (selectedFilterParameters.grades.includes(grade)) {
                      setSelectedFilterParameters({
                        ...selectedFilterParameters,
                        grades: selectedFilterParameters.grades.filter(
                          (g) => g !== grade
                        ),
                      });
                    } else {
                      setSelectedFilterParameters({
                        ...selectedFilterParameters,
                        grades: [...selectedFilterParameters.grades, grade],
                      });
                    }
                  }}
                  style={{
                    minWidth: "initial",
                    backgroundColor: selectedFilterParameters.grades.includes(
                      grade
                    )
                      ? "#6264A7"
                      : undefined,
                    color: selectedFilterParameters.grades.includes(grade)
                      ? "#fff"
                      : undefined,
                  }}
                  size="small"
                >
                  {grade}
                </Pill>
              ))}
            </div>
          </Collapse.Panel>

          <Collapse.Panel header={translation.filter.filterByStatus} key="2">
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {SUBMISSION_STATUSES.map((status) => (
                <Pill
                  key={status}
                  selected={selectedFilterParameters.statuses.includes(status)}
                  selectable
                  onClick={() => {
                    if (selectedFilterParameters.statuses.includes(status)) {
                      setSelectedFilterParameters({
                        ...selectedFilterParameters,
                        statuses: selectedFilterParameters.statuses.filter(
                          (s) => s !== status
                        ),
                      });
                    } else {
                      setSelectedFilterParameters({
                        ...selectedFilterParameters,
                        statuses: [
                          ...selectedFilterParameters.statuses,
                          status,
                        ],
                      });
                    }
                  }}
                  style={{
                    minWidth: "initial",
                    backgroundColor: selectedFilterParameters.statuses.includes(
                      status
                    )
                      ? "#6264A7"
                      : undefined,
                    color: selectedFilterParameters.statuses.includes(status)
                      ? "#fff"
                      : undefined,
                  }}
                  size="small"
                >
                  {status}
                </Pill>
              ))}
            </div>
          </Collapse.Panel>

          <Collapse.Panel header={translation.filter.filterByConfidence} key="3">
            <div style={{ padding: "8px 0" }}>
              <Flex column gap="gap.small">
                <Text>
                  {translation.filter.minimumAiConfidence}: {selectedFilterParameters.confidence || 0}%
                </Text>
                <Slider
                  min={0}
                  max={100}
                  value={selectedFilterParameters.confidence || 0}
                  onChange={handleConfidenceChange}
                  fluid
                />
                <Flex space="between">
                  <Text size="small" color="grey">{translation.filter.confidenceLabels.low}</Text>
                  <Text size="small" color="grey">25%</Text>
                  <Text size="small" color="grey">{translation.filter.confidenceLabels.medium}</Text>
                  <Text size="small" color="grey">75%</Text>
                  <Text size="small" color="grey">{translation.filter.confidenceLabels.high}</Text>
                </Flex>
              </Flex>
            </div>
          </Collapse.Panel>
        </Collapse>

        <div
          style={{
            border: 0,
            display: "flex",
            justifyContent: "space-between",
            marginTop: 40,
          }}
        >
          <Button
            content={translation.filter.clearAllFilters}
            text
            onClick={() => {
              onResetFilter();
              dismissPanel();
            }}
          />
          <Button
            content={translation.filter.applyFilters}
            primary
            onClick={() => {
              onApplyFilter();
              dismissPanel();
            }}
          />
        </div>
      </div>
    </Panel>
  );
};

export default BatchGradingFilterModel;
